import type { InventoryFilters, InventoryGroupFilters } from '@/lib/api/client/inventory'
import type { InventoryGroupLevel } from '@/lib/api/schemas/inventory.schema'
import { requestFilters, requestGroupFilters, type WarehouseUrlState } from '@/lib/warehouse/url-state'

export type WarehouseRequest =
  | {
      kind: 'inventory'
      purpose: 'rows'
      filters: InventoryFilters
      refreshToken: number
    }
  | {
      kind: 'inventory'
      purpose: 'facets'
      filters: InventoryFilters
      signature: string
      refreshToken: number
    }
  | {
      kind: 'groups'
      level: InventoryGroupLevel
      filters: InventoryGroupFilters
      refreshToken: number
    }

function isReconciliationMode(state: WarehouseUrlState): boolean {
  return (state.filters.rowGrain !== undefined && state.filters.rowGrain !== 'piece')
    || state.filters.unresolvedOnly === true
}

function facetFilters(state: WarehouseUrlState): InventoryFilters {
  return {
    ...requestFilters(state),
    include: undefined,
    sort: undefined,
    direction: undefined,
    limit: 1,
    offset: 0,
  }
}

export function facetRequestSignature(state: WarehouseUrlState, refreshToken = 0): string {
  return JSON.stringify({
    filters: state.filters,
    lifecycle: state.lifecycle,
    withPhotos: state.withPhotos,
    refreshToken,
  })
}

export function warehouseRequestPlan(state: WarehouseUrlState, refreshToken = 0): readonly WarehouseRequest[] {
  if (state.grouping === 'none' || isReconciliationMode(state)) {
    return [{ kind: 'inventory', purpose: 'rows', filters: requestFilters(state), refreshToken }]
  }

  return [
    { kind: 'groups', level: state.grouping, filters: requestGroupFilters(state), refreshToken },
    {
      kind: 'inventory',
      purpose: 'facets',
      filters: facetFilters(state),
      signature: facetRequestSignature(state, refreshToken),
      refreshToken,
    },
  ]
}
